/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/14
 * Time: 10:42
 * Desc: 基础设置-试穿及出样设置
 */

import { Component, Vue } from 'vue-property-decorator';

// 子组件
import TryOnSetting from '@/views/components/tryOnSetting/tryOnSetting.vue'; // 试穿设置
import ExampleSetting from '@/views/components/exampleSetting/exampleSetting.vue'; // 出样设置
import ExtendedSetting from '@/views/components/extendedSetting/extendedSetting.vue'; // 其他设置
import NoAuth from '@/views/components/noAuth/noAuth.vue';
@Component({
  components: {
    TryOnSetting,
    ExampleSetting,
    ExtendedSetting,
    NoAuth,
  },
})
export default class TryOnAndExampleSetting extends Vue {
  /* 数据 */

  /**
   * 当前页面的索引
   * @type {string}
   */
  public curPage = '1';

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  /* 方法 */

  /**
   * 切换页面
   */
  public onPageSwitch(key): void {
    this.curPage = key;
    localStorage.setItem('curpage', key);
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-BASIC-TRYON');
    if (this.isContentBodyShow) {
      // 获取当前页索引
      this.curPage = localStorage.getItem('curpage') ? localStorage.getItem('curpage') : '1';
    }
  }
}
